import { Theme, createStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      justifyContent: "space-between",
      backgroundColor: "#FAFAFA",
      borderRadius: "30px 0px 0px 30px",
      padding: "32px 30px",
      marginTop: 11,
      [theme.breakpoints.down(400)]: {
        padding: "15px 10px",
        maxWidth: "100vw",
        margin: 0,
        overflow: "hidden",
      },
    },
    label: {
      fontSize: 16,
      lineHeight: "18.75px",
      color: "#3B465C",
      margin: 0,
    },
    row: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: 0,
      [theme.breakpoints.down(400)]: {
        alignItems: "flex-start",
        flexDirection: "column",
      },
    },
    buttonContent: {
      display: "flex",
      gap: "15px",
      [theme.breakpoints.down(500)]: {
        flexDirection: "column",
      },
    },
    search: {
      borderRadius: 15,
      width: 233,
      "& .MuiOutlinedInput-root": {
        borderRadius: "15px",
      },
    },
    button: {
      backgroundColor: theme.palette.primary.main,
      color: "white",
      borderRadius: 15,
      padding: "14px 21px",
      gap: 15,
      boxShadow: "0px 3px 6px 0px #00000029",
      width: 197,
      height: 50,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
    },
  });
